import { render, staticRenderFns } from "./IconSvgInfinity.vue?vue&type=template&id=4fce13be&scoped=true&"
import script from "./IconSvgInfinity.vue?vue&type=script&lang=js&"
export * from "./IconSvgInfinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce13be",
  null
  
)

export default component.exports